import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
interface LeadFormProps {
  buttonText?: string;
  helperText?: string;
}
export function LeadForm({
  buttonText = 'Claim My Free Week',
  helperText = 'Storm will contact you to confirm student age, goals, class options and the best first visit.'
}: LeadFormProps) {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate form submission
    setTimeout(() => {
      navigate('/thank-you-free-trial');
    }, 800);
  };
  return <form onSubmit={handleSubmit} className="bg-paper p-8 rounded-2xl shadow-xl border border-subtle-gray w-full max-w-md mx-auto" data-id="element-187">
      <div className="flex flex-col gap-5 mb-6" data-id="element-188">
        <div data-id="element-189">
          <label htmlFor="fullName" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-190">
            Full Name
          </label>
          <input type="text" id="fullName" required className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" placeholder="Parent or Student Name" data-id="element-191" />
        </div>

        <div data-id="element-192">
          <label htmlFor="phone" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-193">
            Phone Number
          </label>
          <input type="tel" id="phone" required className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" placeholder="(517) 220-0621" data-id="element-194" />
        </div>

        <div data-id="element-195">
          <label htmlFor="email" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-196">
            Email Address
          </label>
          <input type="email" id="email" required className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" placeholder="email@example.com" data-id="element-197" />
        </div>
      </div>

      <button type="submit" disabled={isSubmitting} className="btn-primary w-full mb-4 disabled:opacity-70" data-id="element-198">
        {isSubmitting ? 'Submitting...' : buttonText}
      </button>

      <p className="text-xs text-gray-warm text-center leading-relaxed" data-id="element-199">
        {helperText}
      </p>
    </form>;
}